import get from 'lodash/get';
import first from 'lodash/first';
import findKey from 'lodash/findKey';
import React from 'react';
import PropTypes from 'prop-types';
import { intlShape } from 'react-intl';
import Head from 'next/head';
import messages from './messages';
import homeMessages from '../common/messages/homes';
import HOC from './index.hoc';
import Form from './components/Forms/Form';
import SeoLinks from './components/SeoLinks.homes';
import SourcesList from '../Sources/list/components/SourcesList/container';
import { dealTypeIdToString } from '../utils/dealType';

const allMessages = { ...messages, homeMessages };

const {
  metaTitle,
  metaDescription,
  metaTitleNoLocation,
  metaDescriptionNoLocation,
  genericPropertyType,
  genericPropertyTypePlural,
} = allMessages;

class Index extends React.Component {
  componentWillReceiveProps(nextProps) {
    if (nextProps.url !== this.props.url) {
      const { url, query, statusCode } = nextProps;
      this.props.locationChange({ url, query, statusCode });
    }
  }

  render() {
    const { intl, indexSeo, query, searchParameters, isFetching } = this.props;
    /* eslint-disable no-param-reassign */
    const config = this.props.config;

    const types = get(config, ['vertical', 'types']);
    const typeIdDefault = parseInt(findKey(types, `${first(types)}`), 10);
    const countryCode = config.countryCode;

    const propertyTypes = get(config, ['vertical', 'property_types']);
    const currentPropertyTypeDecoded = query.property_type && decodeURI(query.property_type);
    const currentPropertyTypeName = propertyTypes[decodeURI(currentPropertyTypeDecoded)];
    const currentDealTypeTranslatedName = intl.formatMessage({
      id: types[`${query.deal_type}`],
    });
    const currentDealTypeString = dealTypeIdToString(query.deal_type);
    const queryDealType = parseInt(query.deal_type, 10);
    const queryParentDealType = parseInt(query.parent_deal_type, 10);
    const isSemUrl = get(searchParameters, 'isSemUrl');

    const indexSeoWhereIn = currentPropertyTypeDecoded
      ? [currentPropertyTypeDecoded, currentDealTypeString]
      : [currentDealTypeString];

    const indexSeoLinks = get(indexSeo, indexSeoWhereIn, []);

    let title = intl.formatMessage(metaTitle);
    let description = intl.formatMessage(metaDescription);

    if (query.routeName !== 'home' && !currentPropertyTypeDecoded && query.deal_type !== '1') {
      const propertyPlural = intl.formatMessage(genericPropertyTypePlural);
      const propertySingular = intl.formatMessage(genericPropertyType);
      title = intl.formatMessage(metaTitleNoLocation, {
        '%1$s': propertyPlural,
        '%2$s': currentDealTypeTranslatedName,
      });
      description = intl.formatMessage(metaDescriptionNoLocation, {
        '%1$s': propertySingular,
        '%2$s': currentDealTypeTranslatedName,
      });
    } else if (query.routeName !== 'home' && currentPropertyTypeDecoded) {
      title = intl.formatMessage(metaTitleNoLocation, {
        '%1$s': currentPropertyTypeName,
        '%2$s': currentDealTypeTranslatedName,
      });
      description = intl.formatMessage(metaDescriptionNoLocation, {
        '%1$s': currentPropertyTypeName,
        '%2$s': currentDealTypeTranslatedName,
      });
    }

    return (
      <div>
        <Head>
          <title>{title}</title>
          <meta name="description" content={description} />
          <meta property="og:title" content={title} />
          <meta property="og:description" content={description} />
        </Head>

        <Form
          countryCode={countryCode}
          onSearchSubmit={this.props.onSearchSubmit}
          typeId={queryDealType}
          typeIdDefault={typeIdDefault}
        />

        <SourcesList />

        {!isSemUrl && (
          <SeoLinks
            propertyTypes={propertyTypes}
            currentPropertyType={currentPropertyTypeDecoded}
            parentDealType={queryParentDealType}
            dealType={queryDealType}
            dealTypes={types}
            links={indexSeoLinks}
            isFetching={isFetching}
          />
        )}
      </div>
    );
  }
}

Index.defaultProps = {
  statusCode: null,
};

Index.propTypes = {
  searchParameters: PropTypes.object.isRequired,
  intl: intlShape.isRequired,
  url: PropTypes.string.isRequired,
  statusCode: PropTypes.number,
  config: PropTypes.object.isRequired,
  locationChange: PropTypes.func.isRequired,
  query: PropTypes.object.isRequired, // eslint-disable-line react/no-unused-prop-types
  indexSeo: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
  isFetching: PropTypes.bool.isRequired,
  onSearchSubmit: PropTypes.func.isRequired,
};

export default HOC(Index);



// WEBPACK FOOTER //
// ./app/Index/index.js